import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./login/LoginPage";
import AuthGuard from "./auth/AuthGuard";
import HomePage from "./home/HomePage";
import Cargo from "./home/Cargo";
function App() {
  return (
    <div
      style={{
        background: "#D9D9D2",
        minwidth: "1500px",
        minHeight: "100vh",
        margin: "0 auto",
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={ <AuthGuard> <HomePage /> </AuthGuard> } />
          <Route path="/cargo" element={<AuthGuard><Cargo /></AuthGuard>} />
          {/* Add more routes as needed */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;